import { Loader } from 'src/design/atoms/Loader';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Switch } from 'src/design/atoms/Switch';
import { Textarea } from 'src/design/atoms/Textarea';
import React from 'react';
import { formatDate } from 'src/utils';
import { JobUserDto, TimesheetDto } from 'src/api/FiretrolApiClient';
import { TimesheetForm } from 'src/routes/Operations/Daily/components/TimesheetForm';
import { StepProps } from './types';

export interface TimesheetsStepProps extends StepProps {
  timesheets: TimesheetDto[];
  team: JobUserDto[];
  onTimesheetChanged: (timesheet: TimesheetDto) => void;
  loading: boolean;
  error?: string;
}

export const TimesheetsStep: React.FC<TimesheetsStepProps> = ({
  values,
  setFieldValue,
  setFieldTouched,
  selectedJob,
  timesheets,
  team,
  onTimesheetChanged,
  loading,
  error,
}) => {
  return (
    <>
      <Switch
        label={`No Timesheets for ${formatDate(values.date)}`}
        checked={values.excludeTimesheets}
        onChange={(event) => {
          setFieldValue('excludeTimesheets', event.currentTarget.checked);
          setFieldTouched('excludeTimesheets', true, false);
        }}
      />

      {values.excludeTimesheets && (
        <Textarea
          label="Reason for exclusion"
          placeholder="Explain why timesheets are excluded..."
          value={values.exclusionTimesheetsReason || ''}
          onChange={(e) =>
            setFieldValue('exclusionTimesheetsReason', e.target.value)
          }
          maxLength={1000}
          rows={3}
          mt="md"
          withAsterisk
          error={error}
        />
      )}

      {!values.excludeTimesheets && selectedJob && (
        <>
          {loading && (
            <Stack align="center" mt="md">
              <Loader />
              <Text c="dimmed" size="sm">
                Loading timesheets...
              </Text>
            </Stack>
          )}
          {!loading && team.length === 0 && (
            <Text c="dimmed">No team found for this job.</Text>
          )}
          {!loading && team.length > 0 && (
            <TimesheetForm
              timesheets={timesheets}
              team={team}
              selectedDate={values.date}
              selectedJob={selectedJob}
              onTimesheetChanged={onTimesheetChanged}
            />
          )}
        </>
      )}
    </>
  );
};
